<template>
  <h1 v-if="isPayementAgreement == 'true'" class="w-full text-3xl text-center p-6" data-cy="adyen-payement-agreement-title">
    {{ $t('payment.adyenPayementAgreement') }}
  </h1>
  <h1 v-else class="w-full text-3xl text-center p-6" data-cy="adyen-payement-title">
    {{ $t('payment.adyenPayment') }}
  </h1>
  <div v-if="!isLoaded" class="flex flex-wrap justify-center text-center">
    {{ $t('payment.loadingPleaseWait') }}
  </div>
  <div v-if="!hideAdyenContainer && !adyenError && !exerpError" class="flex flex-wrap justify-center text-center">
    <div id="dropin-container" class="md:w-1/2 justify-center text-center"></div>
  </div>
  <div v-else-if="adyenError" class="flex flex-wrap justify-center text-center" data-cy="adyen-error">
    {{ $t('payment.adyenProblem') }}:
    {{ adyenError }}
  </div>
  <div v-else-if="exerpError" class="flex flex-wrap justify-center text-center">
    {{ $t('payment.paymentProcessProblem') }}:
    {{ $t(exerpError) }}
  </div>
  <div v-if="checkingPayment" class="flex flex-wrap justify-center">
    <div class="w-full md:w-2/3 lg:w-1/2 bg-white border border-gray-200 rounded shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-4 text-center">
        {{ $t('payment.checkingThePayment') }}
      </h2>
      <div class="mt-4 mb-4 text-center text-sm text-gray-600">
        <p v-if="showStillChecking1">{{ $t('payment.stillChecking1') }}</p>
        <p v-if="showStillChecking2">{{ $t('payment.stillChecking2') }}</p>
      </div>
      <div class="space-y-4">
        <div class="flex items-center justify-between border border-gray-100 rounded-md px-4 py-3">
          <div class="text-left">
            <p class="font-medium">{{ $t('payment.paymentAuthorization') }}</p>
            <p class="text-xs text-gray-500">{{ $t('payment.awaitingConfirmation') }}</p>
          </div>
          <div class="ml-4">
            <svg
              v-if="sessionState?.paymentAuthorised"
              class="w-6 h-6 text-green-500"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <svg v-else class="w-6 h-6 text-blue-500 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16 8 8 0 01-8-8z"></path>
            </svg>
          </div>
        </div>

        <div v-if="sessionState?.isRecurring" class="flex items-center justify-between border border-gray-100 rounded-md px-4 py-3">
          <div class="text-left">
            <p class="font-medium">{{ $t('payment.securingRecurringPaymentMethod') }}</p>
            <p class="text-xs text-gray-500">
              {{ $t('payment.tokenisingPaymentMethod') }}
            </p>
          </div>
          <div class="ml-4">
            <svg
              v-if="sessionState.tokenId"
              class="w-6 h-6 text-green-500"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <svg v-else class="w-6 h-6 text-blue-500 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16 8 8 0 01-8-8z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div class="mt-6 text-left bg-gray-50 border border-gray-200 rounded-md px-4 py-3 text-sm font-mono">
        <!-- Message that says Please wait while we're processing your payment -->
        <p class="mb-1">
          <span class="font-semibold text-gray-600">
            {{ $t('payment.pleaseWaitProcessingPayment') }}
          </span>
        </p>
        <p class="mb-1">
          <span class="font-semibold text-gray-600"> {{ $t('payment.statusLabel') }}: </span>
          <span class="ml-2">{{ sessionState?.status }}</span>
        </p>
        <p v-if="sessionState?.pspReference" class="mb-1">
          <span class="font-semibold text-gray-600"> {{ $t('payment.pspReference') }}:</span>
          <span class="ml-2">{{ sessionState.pspReference }}</span>
        </p>
        <p v-if="sessionState?.tokenId && sessionState.tokenSource" class="mb-1">
          <span class="font-semibold text-gray-600"> {{ $t('payment.tokenSource') }}:</span>
          <span class="ml-2">{{ sessionState.tokenSource }}</span>
        </p>
      </div>

      <div class="mt-4 text-center text-xs text-gray-500">{{ tmpCounter }}</div>
    </div>
  </div>
</template>

<script lang="ts" src="./AdyenDropIn.ts" />
